import { useEffect } from 'react'
import axios from 'axios'
import { storageService } from 'services'

const useAcceptLanguage = () => {
  useEffect(() => {
    const axiosInterceptor = axios.interceptors.request.use((config) => {
      const language = storageService.getLanguage()
      if (language) {
        config.headers = { ...config.headers, 'Accept-Language': language }
      }
      return config
    })

    return () => {
      axios.interceptors.request.eject(axiosInterceptor)
    }
  }, [])
}

export default useAcceptLanguage
